import React, { useState } from 'react';

function ToolsBanner() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const tools = [
    {
      name: 'Privacy Rights',
      url: 'https://privacyrights.compliancehub.wiki/',
      icon: 'fa-shield-halved',
      color: 'text-blue-400'
    },
    {
      name: 'Biometric Laws',
      url: 'https://biometric.myprivacy.blog/',
      icon: 'fa-fingerprint',
      color: 'text-green-400'
    },
    {
      name: 'PII Guide',
      url: 'https://pii.compliancehub.wiki/',
      icon: 'fa-lock',
      color: 'text-purple-400'
    },
    {
      name: 'Breach Notice',
      url: 'https://notification.breached.company/',
      icon: 'fa-bell',
      color: 'text-red-400'
    },
    {
      name: 'Global Map',
      url: 'https://globalcompliancemap.com/',
      icon: 'fa-earth-americas',
      color: 'text-cyan-400'
    }
  ];

  return (
    <div className="bg-white border-b-2 border-purple-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-gray-700 text-sm flex-shrink-0">
            <i className="fas fa-tools text-purple-600"></i>
            <span className="font-semibold hidden sm:inline">More Tools:</span>
          </div>

          <div className="flex items-center gap-3 md:gap-6 overflow-x-auto flex-1 mx-4 scrollbar-hide">
            {tools.map((tool, index) => (
              <a
                key={index}
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:opacity-70 transition-opacity whitespace-nowrap flex-shrink-0"
                title={tool.name}
              >
                <i className={`fas ${tool.icon} ${tool.color} text-base`}></i>
                <span className="text-gray-900 text-sm font-medium">{tool.name}</span>
              </a>
            ))}
          </div>

          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 ml-2"
            aria-label="Close banner"
          >
            <i className="fas fa-times text-sm"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ToolsBanner;
